export default "__VITE_ASSET__fjr9fyTY__"